import { useBorrowerIsDelinquentOnDebts } from '../../../../../../../queries/BorrowerFields/LegalityFields';
import { ToggleButtonLabelSize, YesNoToggleButton } from '@apply/components';
import { ButtonGroupTypes } from 'devextreme-react/button-group';
import { ApplicationQuestionReviewItem } from '../../../../../../components/ApplicationQuestionReviewItem';

interface DelinquentOnRealEstateDebtProps {
    required?: boolean;
    isReview?: boolean;
}

export const DelinquentOnRealEstateDebt: React.FC<DelinquentOnRealEstateDebtProps> = ({ required = false, isReview = false }) => {
    const label = 'Delinquent on any real estate debts?';
    const [delinquentOnDebts, set_delinquentOnDebts] = useBorrowerIsDelinquentOnDebts();

    const toggleButtonYesNoClick = (e: ButtonGroupTypes.ItemClickEvent) => {
        switch (e.itemData?.id.toLowerCase()) {
            case 'yes':
                set_delinquentOnDebts(true);
                return;
            case 'no':
                set_delinquentOnDebts(false);
                return;
            default:
                return;
        }
    };

    const parseDisplayValue = (value: boolean | undefined) => {
        if (value) {
            if (value == true || value == 'true') {
                return 'Yes';
            } else if (value == false || value == 'false') {
                return 'No';
            }
        }
        return '';
    };

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={parseDisplayValue(delinquentOnDebts)}
                />
            ) : (
                <YesNoToggleButton
                    id='delinquentOnDebts'
                    value={delinquentOnDebts}
                    onItemClick={toggleButtonYesNoClick}
                    width='230px'
                    height='40px'
                    required={required}
                    requiredMessage='Delinquent on debts required'
                    label={label}
                    labelSize={ToggleButtonLabelSize.Medium}
                />
            )}
        </>
    );
};
